import type { Theme } from './types';

/**
 * BẠCH KIM — than chì, bạch kim lạnh, phẳng hoàn toàn, chữ giãn rộng.
 *
 * Sang trọng bằng cách bớt đi chứ không thêm vào: không một bóng đổ nào, viền mảnh
 * như sợi tóc, màu chủ đạo là bạc lạnh chứ không phải màu bão hòa, nhãn viết hoa và
 * giãn chữ rộng. Nội dung kẹp hẹp lại giữa màn hình để trang có lề thở.
 *
 * Tính cách: kín đáo, đắt tiền, ít nói — hợp thương hiệu nhắm khách đặt cược lớn.
 *
 * Vì màu chủ đạo là màu SÁNG, chữ đặt trên nó phải là màu tối. Đó là lý do
 * `brand-contrast` và `text-on-brand` ở giao diện này ngược chiều với ba giao diện kia.
 */
export const bachKim: Theme = {
  id: 'bach-kim',
  brandName: 'BẠCH KIM',
  tagline: 'Than chì, bạch kim lạnh, phẳng hoàn toàn — kín đáo và đắt tiền.',

  scheme: 'dark',
  layout: 'top',
  navStyle: 'bar',
  mark: 'khoi-vuong',

  fonts: {
    display: "'Montserrat'",
    body: "'Inter'",
    href: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@500;600;700&family=Inter:wght@400;500;600&display=swap',
  },

  tokens: {
    'bg-root': '#0d0e10',
    'bg-surface': '#15171a',
    'bg-raised': '#1c1f23',
    'bg-overlay': '#23272c',
    'bg-input': '#101214',
    'bg-hover': '#22262b',

    brand: '#c6d0dc',
    'brand-strong': '#e9eff6',
    'brand-dim': '#79838f',
    'brand-contrast': '#0d0e10',
    accent: '#5589bd',

    positive: '#4f9e6a',
    'positive-dim': '#22392b',
    negative: '#c26a6a',
    'negative-dim': '#3d2626',
    warning: '#c2a05a',
    info: '#5589bd',
    'odds-up': '#4f9e6a',
    'odds-down': '#c26a6a',

    'text-primary': '#e4e8ee',
    'text-secondary': '#98a1ac',
    'text-muted': '#6b737d',
    'text-disabled': '#474d55',
    'text-on-brand': '#0d0e10',
    'text-inverse': '#0d0e10',

    border: '#22262b',
    'border-strong': '#333940',

    // Phẳng hoàn toàn. Chiều sâu đến từ độ sáng của nền, không từ bóng đổ.
    'shadow-sm': 'none',
    'shadow-md': 'none',
    'shadow-lg': '0 0 0 1px #333940',

    'font-display': "'Montserrat', 'Segoe UI', system-ui, sans-serif",
    'font-sans': "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif",

    'radius-sm': '2px',
    'radius-md': '3px',
    'radius-lg': '4px',
    'radius-xl': '6px',
    /* `--radius-full` la khoa hinh VIEN THUOC (the, nhan, tab), khong phai hinh tron
       tuyet doi — khong cho nao dung no cho anh dai dien hay cham tron. Nen mot thuong
       hieu lay goc vuong lam nhan dien duoc phep vuong hoa ca nhung cho nay; de nguyen
       999px thi nut chinh bo tron lop lop giua mot trang toan goc nhon, nhin ra ngay
       la hai bo quy tac danh nhau.
       Bo rat nhe, dung thang do kiem che cua giao dien nay. */
    'radius-full': '3px',

    'header-height': '64px',
    'content-max': '1180px',
    'brand-tracking': '0.26em',
    'label-tracking': '0.13em',
    'label-transform': 'uppercase',
  },
};
